import React, { lazy, Suspense } from "react";
import "./teamrelys.css";
import RelyDesktop from "../images/RelyDesktop.svg";

const ProductCard = lazy(() => import("./product-card-animation/ProductCard"));

const TeamRelys = () => {
  const demoCards = [
    {
      id: 1,
      imgUrl: "/images/TamperProof 2.svg",
      apiName: "Tampering Detection",
      successMsg:
        "Uncover forged edits, metadata gaps, and hidden file manipulations instantly.",
      timeStamp: "just now",
    },
    {
      id: 2,
      imgUrl: "/images/Loan EMI.svg",
      apiName: "Loan and EMI Tracking",
      successMsg:
        "Map FOIR, active EMIs, and recent borrowings across accounts.",
      timeStamp: "1 second ago",
    },
    {
      id: 3,
      imgUrl: "/images/Clip path group.svg",
      apiName: "Adjusted and Forecasted Balances",
      successMsg: "View ABB with bounce adjustments plus a 30-day projection.",
      timeStamp: "3 second ago",
    },
    {
      id: 4,
      imgUrl: "/images/AI Income.svg",
      apiName: "AI Income Classification",
      successMsg:
        "Automatically tag salary, rent, and business inflows with accuracy.",
      timeStamp: "6 second ago",
    },
    {
      id: 5,
      imgUrl: "/images/Risk Signal.svg",
      apiName: "Behavioral Risk Signals",
      successMsg:
        "Spot salary drops, bounce patterns, and inflow irregularities early.",
      timeStamp: "6 second ago",
    },
    {
      id: 6,
      imgUrl: "/images/Document OCR 2.svg",
      apiName: "Decision-Ready Reports",
      successMsg:
        "Get clear, accurate insights in reports that are easy to understand.",
      timeStamp: "6 second ago",
    },
    
  ];

  return (
    <div className="team-rely">
      <div className="team-rely-one">
        <h1 className="team-rely-heading">
          Why Leading Teams Choose <span>BeFiSc</span>
        </h1>
        <p className="team-rely-para">
          BeFiSc's Bank Statement Analyzer uncovers risks in seconds, eliminates
          manual checks, and drives confident, faster credit decisions.
        </p>
      </div>

      <div className="team-rely-cards">
        {/* scroll card */}
        <div>
          <Suspense fallback={<div>Loading Product...</div>}>
            <ProductCard
              cardsData={demoCards}
              backgroundColor="#00C7EB"
              intervalTime={3000}
              maxVisibleCards={4}
            />
          </Suspense>
        </div>

        {/* right container */}
        <div className="team-right-container">
          {/* Desktop images */}
          <div className="desktop-images">
            <img src={RelyDesktop} alt="Befisc" />
          </div>

          {/* Mobile image */}
          <div className="mobile-image">
            <img src={RelyDesktop} alt="Befisc mobile" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamRelys;